import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaFacebookSquare, FaInstagram, FaTwitter, FaHeart, FaEnvelope } from 'react-icons/fa';
import { MdLocalPhone, MdLocationPin, MdArrowRightAlt } from 'react-icons/md';

const Footer = () => {

  const currentYear = new Date().getFullYear()

  return (
    <section id="footer" className="">
      <div className="register-area">
        <div className="container">
          <h2>Are you an estate agent or developer? List your property for FREE.</h2>
          <NavLink to="/signup">Register Now</NavLink>
        </div>
      </div>
      <div className="footer-area">
        <div className="footer-area_sup">
          <div className="container">
            <div className="footer_sup-grid">
              <div className="footer_sup-item">
                <h3><span>Island Luxury Property Listing</span></h3>
                <div className="contact-details">
                  <div className="contact-details_item">
                    <div>
                      <div className="contact-details_icon">
                        <MdLocationPin size={20} />
                      </div>
                    </div>
                    <span>Block B2, Nile Road, Ocean Bay Estate Orchid Road, Lekki-Phase II Lagos, Nigeria.</span>
                  </div>
                  <div className="contact-details_item">
                    <div>
                      <div className="contact-details_icon">
                        <FaEnvelope size={20} />
                      </div>
                    </div>
                    <span>contact@islandluxurypropertylistings.com</span>
                  </div>
                  <div className="contact-details_item">
                    <div>
                      <div className="contact-details_icon">
                        <MdLocalPhone size={20} />
                      </div>
                    </div>
                    <a href="tel:2349139007777">(+234) 913 900 7777</a>
                  </div>
                </div>
              </div>
              <div className="footer_sup-item useful-links">
                <h3><span>Useful Links</span></h3>
                <ul>
                  <li>
                    <NavLink to="/about">About</NavLink>
                  </li>
                  <li>
                    <NavLink to="/signup">Market Your Property</NavLink>
                  </li>
                  <li>
                    <NavLink to="/contact">Contact</NavLink>
                  </li>
                  <li>
                    <NavLink to="/login">Sign In</NavLink>
                  </li>
                  {/* <li>
                    <NavLink to="/agents">Estate Agents</NavLink>
                  </li> */}
                  {/* <li>
                    <NavLink to="/faqs">FAQs</NavLink>
                  </li> */}
                </ul>
              </div>
              {/* <div className="footer_sup-item suscribe-area">
                <h3><span>Subscribe</span></h3>
                <form>
                  <input type="email" placeholder="Enter your email" />
                  <button type="submit"><MdArrowRightAlt /></button>
                </form>
                <p>Subscribe to our newsletter to get alerts on when we have new properties available.</p>
              </div> */}
            </div>
          </div> 
        </div>
        <div className="footer-area_sub">
          <div className="container">
            <p>&copy; {currentYear} Island Luxury. All rights reserved | <NavLink to="/terms"> Terms</NavLink></p>
            <div className="social-media_icons">
              <a href="https://www.facebook.com/Island-Luxury-Property-Listings-148983607283502" target="_blank" rel="noopener noreferrer">
                <FaFacebookSquare size={25} />
              </a>
              <a href="https://www.instagram.com/islandluxurypropertylistings/" target="_blank" rel="noopener noreferrer">
                <FaInstagram size={25} />
              </a>
              <a href="https://twitter.com/islandluxury22" target="_blank" rel="noopener noreferrer">
                <FaTwitter size={25} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Footer;